import EventCtrl from './controllers/index';
import EventShowCtrl from './controllers/show';
import EventMessageCtrl from './controllers/edit';
import EventPageCtrl from './controllers/page';
import event from './directives/event';
import eventMessage from './directives/event-message';
import templateSelector from './directives/template-selector';
import eventMessageScheduler from './directives/event-message-scheduler';
import publishPageScheduler from './directives/publish-page-scheduler';
import eventSettings from './directives/event-settings';
import sogetiSettingsEditor from './directives/sogeti-settings-editor';
import addSubscribersToEvent from './directives/add-subscribers-to-event';
import eventSubscriberInfo from "./directives/event-subscriber-info";
import surveyList from "./directives/survey-list";
import uirouter from 'angular-ui-router';
import routing from './event.routes';
import Event from './event.repository';
import Sogeti from './services/sogeti';

export default angular.module('app.event', [uirouter])
    .config(routing)
    .controller('EventCtrl', EventCtrl)
    .controller('EventShowCtrl', EventShowCtrl)
    .controller('EventMessageCtrl', EventMessageCtrl)
    .controller('EventPageCtrl', EventPageCtrl)
    .directive('event', () => new event)
    .directive('eventMessage', () => new eventMessage)
    .directive('templateSelector', () => new templateSelector)
    .directive('eventMessageScheduler', () => new eventMessageScheduler)
    .directive('eventSettings', () => new eventSettings)
    .directive('sogetiSettingsEditor', () => new sogetiSettingsEditor)
    .directive('addSubscribersToEvent', () => new addSubscribersToEvent)
    .directive('publishPageScheduler', () => new publishPageScheduler)
    .directive('surveyList', () => new surveyList)
    .directive('eventSubscriberInfo', () => new eventSubscriberInfo())
    .service('Event', Event)
    .service('Sogeti', Sogeti)
    .name;
